(function($){

	var variant_title = $('[name="option-0"]:checked').val();
	var variant_price = $('.HorizontalList__Item.active').attr('data-price');
	$('.addtotrigger').find('.money').text(variant_price);
	$('.number_variant').text(variant_title);

	$(document).on( "click", ".SizeSwatch__Radio", function() {
		let variant_name = $(this).val();
    	$('.number_variant').text(variant_name); 
  		var variant_price = $('.HorizontalList__Item.active').attr('data-price');
    	$('.addtotrigger').find('.money').text(variant_price);
	});

	if(document.querySelector(".product__sticky")){
    	window.addEventListener("scroll", function(){
      		document.querySelector(".product__sticky").style.top = `${document.querySelector("#shopify-section-header").offsetHeight}px`;
      		let addToCartOffsetHeight = document.querySelector(".product-form-container .ProductForm__AddToCart").offsetTop + document.querySelector(".product-form-container .ProductForm__AddToCart").offsetHeight + document.querySelector("#shopify-section-header").offsetHeight;
      		
      		if(window.pageYOffset > addToCartOffsetHeight){
        		document.querySelector(".product__sticky").classList.add("js--sticky-wrapper");
      		} else {
        		document.querySelector(".product__sticky").classList.remove("js--sticky-wrapper");
      		}
    	});
  	}

  	$(document).ready(function(){
  		$('.addtotrigger').on("click", function() {
	        $('.Product .ProductForm__AddToCart').trigger('click');
	    });


  		if ($('.current_qty').length > 0) {
        	$('.variant_name').hide();

        	$(".plus-new").click(function() {
	            let $input = $(this).prev('input.current_qty');
	            let val = parseInt($input.val());

	            var val_update = val + 1;
	            
	            if (val_update > 1) {
	                $('.variant_name').show();
	                $('.number_variant_single').hide();
	                $('.variant_bracket').hide();
	                var abtest = $('.nunber_product').find('.QuantitySelector__CurrentQuantity').val(val_update);
	            }

            	var dd = $('.nunber_product').find('.QuantitySelector__CurrentQuantity').val()
        	});
        
        	$(".minus-new").click(function() {
            	$('.variant_name').hide();
            	let $input = $(this).next('input.current_qty');
            	var val = parseInt($input.val());

            	if (val > 1) {
                	$('.variant_name').show();
                	$('.nunber_product').find('.QuantitySelector__CurrentQuantity').val(val - 1).change();
            	}
        	});
    	}

  	});

})(jQuery);